'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactSortableHoc = require('react-sortable-hoc');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reorder = function reorder(list, startIndex, endIndex) {
  var result = (0, _from2.default)(list);

  var _result$splice = result.splice(startIndex, 1),
      _result$splice2 = (0, _slicedToArray3.default)(_result$splice, 1),
      removed = _result$splice2[0];

  result.splice(endIndex, 0, removed);

  //have to update previousContentId here

  for (var i in result) {
    console.log(result);
    console.log(i);
    if (i == 0) {
      console.log(result[i]);
      result[i].previousContentId = 0;
    } else {
      console.log(result[i - 1]);
      result[i].previousContentId = result[i - 1].id;
    }
  }

  return result;
};

//Find a way to not use this *value*
var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref) {
  var value = _ref.value;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: 'dnd_item', onMouseEnter: function onMouseEnter() {} },
      'Hey'
    ),
    _react2.default.createElement(
      'div',
      null,
      value
    ),
    _react2.default.createElement(
      'div',
      null,
      'text'
    )
  );
});

var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref2) {
  var items = _ref2.items;

  return _react2.default.createElement(
    'div',
    { className: 'dnd_container' },
    items.map(function (item, index) {
      return _react2.default.createElement(SortableItem, { key: 'item-' + index, index: index, value: item.id });
    })
  );
});

var Boxs = function (_React$Component) {
  (0, _inherits3.default)(Boxs, _React$Component);

  function Boxs(props) {
    (0, _classCallCheck3.default)(this, Boxs);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Boxs.__proto__ || (0, _getPrototypeOf2.default)(Boxs)).call(this, props));

    console.log("conten_dnd");
    console.log(props);
    _this.state = {
      list: props.content ? props.content : []
    };
    return _this;
  }

  (0, _createClass3.default)(Boxs, [{
    key: 'onSortEnd',
    value: function onSortEnd(_ref3) {
      var oldIndex = _ref3.oldIndex,
          newIndex = _ref3.newIndex;

      console.log(oldIndex);
      console.log(newIndex);
      console.log(this.state.list);

      this.setState({
        list: reorder(this.state.list, oldIndex, newIndex)
      });
      console.log(this.state.list);

      this.props.onChange(this.state.list);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // console.log("componentWillReceiveProps");
      // console.log(nextProps);
      // console.log(nextProps.content)
      this.setState({ list: nextProps.content });
    }
  }, {
    key: 'render',
    value: function render() {
      console.log("eeeee");
      console.log(this.props.content);
      console.log(this.state.list);
      // this.state.list = this.props.content;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(SortableList, { items: this.state.list, onSortEnd: this.onSortEnd.bind(this), axis: 'xy' })
      );
    }
  }]);
  return Boxs;
}(_react2.default.Component);

;

var Slider = function (_React$Component2) {
  (0, _inherits3.default)(Slider, _React$Component2);

  function Slider(props) {
    (0, _classCallCheck3.default)(this, Slider);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).call(this, props));

    _this2.state = {
      value: _this2.props.value
    };
    return _this2;
  }

  (0, _createClass3.default)(Slider, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ value: nextProps.value });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', null);
    }
  }]);
  return Slider;
}(_react2.default.Component);

var SortableComponent = function (_React$Component3) {
  (0, _inherits3.default)(SortableComponent, _React$Component3);

  function SortableComponent(props) {
    (0, _classCallCheck3.default)(this, SortableComponent);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (SortableComponent.__proto__ || (0, _getPrototypeOf2.default)(SortableComponent)).call(this, props));

    _this3.state = {
      value: 50
    };
    _this3.onSlideEnd = _this3.onSlideEnd.bind(_this3);
    return _this3;
  }

  (0, _createClass3.default)(SortableComponent, [{
    key: 'onSlideEnd',
    value: function onSlideEnd(e) {
      this.setState({ value: e.target.value });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(Boxs, {
          content: this.props.content,
          onChange: this.props.onChange
        })
      );
    }
  }]);
  return SortableComponent;
}(_react2.default.Component);

exports.default = SortableComponent;
;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Content/SortableComponent.js
// module id = 1499
// module chunks = 0